module.exports = __webpack_public_path__ + "img/panelist-cancel.0d08ab3e.svg";